module.exports = __webpack_public_path__ + "img/error-cross.fb259fbc.png";